module.exports = __webpack_public_path__ + "f2d345590357e632802bbb6b810e992a.png";